import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/customer/$customerId/_layout/_index/')({
  component: () => null
});